import { Box } from '@mui/material';
import { GridToolbarContainer } from "@mui/x-data-grid-premium";
import { useState } from "react";
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import { MultiEditPopup } from "./MultiLineEdit";
import CustomButton from 'src/core/ui/CustomButton';

export function CustomToolbar(tableSettings) {
  return (
    <GridToolbarContainer>
      {/* <GridToolbarQuickFilter></GridToolbarQuickFilter> */}
      {/* <GridToolbarColumnsButton /> */}
      {/* <GridToolbarFilterButton /> */}
      {/* <GridToolbarDensitySelector /> */}
      {/* {tableSettings?.checkboxSelection ?
                <MultiEditButton tableSettings={tableSettings}></MultiEditButton>
                : null} */}
      {/* <Button
                disabled={!tableSettings?.hasUnsavedRows || tableSettings?.isSaving}
                onClick={() => {
                    tableSettings?.discardChanges()
                }}
                startIcon={<RestoreIcon />}
            >
                Discard changes
            </Button> */}
      {/* <GridToolbarExport /> */}
    </GridToolbarContainer>
  );
}

const MultiEditButton = ({ tableSettings }) => {
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => { setOpen(true); };
  const handleClose = () => { setOpen(false); };
  return (
    <>
      <Box sx={{ width: 'fit-content' }}><CustomButton title="Edit Multiple Rows" variant="text" disabled={!tableSettings?.rowSelectionModel?.length} onClick={handleClickOpen} icon={<AppRegistrationIcon />} /></Box>
      <MultiEditPopup open={open} onClose={handleClose} tableSettings={tableSettings} />
    </>
  );
};
